var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMunitions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;}\n\t.st1{clip-path:url(#SVGID_00000087381842623502755130000000917524432303212436_);}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    d: "M15.03,16.91C15.01,10.1,12.66,2.79,7.52,2.79S0.03,10.1,0.01,16.91H15.03z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    d: "M0.01,18.85v25.46c0,1.6,1.3,2.9,2.9,2.9c0,0,0,0,0,0h9.21c1.6,0,2.9-1.3,2.91-2.9c0,0,0,0,0,0V18.85H0.01z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M32.51,16.91C32.49,10.1,30.14,2.79,25,2.79s-7.49,7.31-7.51,14.12H32.51z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M17.49,18.85v25.46c0,1.6,1.3,2.9,2.9,2.9c0,0,0,0,0,0h9.21c1.6,0,2.9-1.3,2.91-2.9c0,0,0,0,0,0V18.85H17.49z "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    d: "M49.99,16.91c-0.02-6.81-2.37-14.12-7.51-14.12s-7.49,7.31-7.51,14.12H49.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    d: "M34.97,18.85v25.46c0,1.6,1.3,2.9,2.9,2.9l0,0h9.21c1.6,0,2.9-1.3,2.91-2.9c0,0,0,0,0,0V18.85H34.97z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMunitions);
export default __webpack_public_path__ + "static/media/Icon_Munitions.2f23bb3c9a8de3d95189b19f5b005db1.svg";
export { ForwardRef as ReactComponent };